import isURL from 'validator/lib/isURL';

import { EMBED_URL_PARSERS } from './consts';

//ref: https://stackoverflow.com/questions/1912501/unescape-html-entities-in-javascript
const htmlDecode = (input: string) => {
  const e = document.createElement('textarea');
  e.innerHTML = input;

  return e.childNodes[0].nodeValue!;
};

const getUrlFromEmbedHtml = (htmlString: string) =>
  htmlString.match(/\bhttps?:\/\/\S+/gi)![0].split('"')[0];

export const getIframeSrc = (inputString: string) => {
  const url = htmlDecode(
    inputString.includes('</iframe>') ? getUrlFromEmbedHtml(inputString) : inputString,
  );
  if (!isURL(url)) {
    return {
      parsedUrl: '',
      url: '',
    };
  }

  let parsedUrl = url;

  EMBED_URL_PARSERS.some((parser) => {
    if (parser.condition(url)) {
      const embedString = parser.getEmbedString(url);
      if (embedString) {
        parsedUrl = embedString;
        return true;
      }
    }
    return false;
  });

  return {
    parsedUrl,
    url,
  };
};
